import { render, staticRenderFns } from "./AssembleList.vue?vue&type=template&id=ba3201be&scoped=true"
import script from "./AssembleList.vue?vue&type=script&lang=js"
export * from "./AssembleList.vue?vue&type=script&lang=js"
import style0 from "./AssembleList.vue?vue&type=style&index=0&id=ba3201be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3201be",
  null
  
)

export default component.exports